module.exports = __webpack_public_path__ + "img/payment.a4af1afd.svg";